import { ApiProperty } from "@nestjs/swagger";
import { isNumber } from "util";

export class CompanyIdRequest {
    @ApiProperty()
    companyId: number;
    @ApiProperty()
    username?: string;

    constructor(companyId: number, username?: string) {
        this.companyId = companyId;
        this.username = username;
    }
}

export class WhatsappLogRequest{
    @ApiProperty()
    companyId?:number;
    @ApiProperty()
    moduleId?:number;
    @ApiProperty()
    fromDate?:Date;
    @ApiProperty()
    toDate?:Date

}